export default {
  online_payments_off:
    'Toimitus on päällä, mutta asiakkaat eivät voi tilata sitä: kuriiritoimitus maksetaan vain verkossa, ja verkkomaksut ovat pois päältä.',
  gateway_not_verified:
    'Toimitus on päällä, mutta asiakkaat eivät voi tilata sitä: kuriiritoimitus maksetaan vain verkossa, ja verkkomaksut on keskeytetty, kunnes maksutilisi on vahvistettu.',
  stripe_processing_fee_missing:
    'Toimitus on päällä, mutta asiakkaat eivät voi tilata sitä: kuljetettu toimitus maksetaan vain verkossa, ja verkkomaksut on keskeytetty, kunnes kumppanisi asettaa käsittelymaksun.',
  turn_on_online_payments: 'Ota verkkomaksut käyttöön',
};
